import React from 'react';
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from './ui/accordion';
import { faqs } from '../mock';

const FAQSection = () => {
  return (
    <section className="py-24 bg-gradient-to-b from-[#F7F9FB] to-white">
      <div className="max-w-4xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-5xl font-bold text-[#0B0F14] mb-6">
            Frequently Asked Questions
          </h2>
          <p className="text-xl text-[#5F6B7A]">
            Everything you need to know about our services
          </p>
        </div>

        <div className="backdrop-blur-xl bg-white/80 rounded-3xl shadow-2xl border border-white/50 p-8">
          <Accordion type="single" collapsible className="w-full space-y-4">
            {faqs.map((faq, index) => (
              <AccordionItem 
                key={index} 
                value={`item-${index}`}
                className="border border-gray-200 rounded-2xl px-6 hover:border-[#0077BE] transition-colors duration-300"
              >
                <AccordionTrigger className="text-left text-lg font-semibold text-[#0B0F14] hover:text-[#0077BE] py-5 hover:no-underline">
                  {faq.question}
                </AccordionTrigger>
                <AccordionContent className="text-[#5F6B7A] leading-relaxed pb-5">
                  {faq.answer}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
      </div>
    </section>
  );
};

export default FAQSection;
